import countries from './countries/routes'

const CityIndex = () => import('./views/CityIndex.vue')
const CityCreate = () => import('./views/CityCreate.vue')
const CityEdit = () => import('./views/CityEdit.vue')

export default [
  {
    path: 'cities',
    name: 'cities.index',
    component: CityIndex
  },
  {
    path: 'cities/create',
    name: 'cities.create',
    component: CityCreate
  },
  {
    path: 'cities/:cityId(\\d+)',
    name: 'cities.edit',
    component: CityEdit
  },
  ...countries
]
